import { css } from '@emotion/core';
import { media, variables } from '@domain-group/fe-brary';
var global = variables.global;
export var container = /*#__PURE__*/css("position:fixed;top:0;left:0;width:100%;height:calc(100% - 80px);z-index:", global.layerModal, ";", media('>=tablet'), "{height:100%;position:relative;z-index:auto;}");
export var bottomSection = {
  name: "uzte6q",
  styles: "display:flex;justify-content:stretch;"
};
export var bottomRightSection = {
  name: "i9gxme",
  styles: "flex-grow:1;"
};
export var bottomLeftSection = {
  name: "8mg22s",
  styles: "margin-right:20px;"
};
export var map = /*#__PURE__*/css("position:fixed;top:0;left:0;align-items:center;justify-content:center;width:100%;height:inherit;z-index:", global.layerModal, ";", media('>=tablet'), "{position:static;position:initial;width:100%;height:auto;}", media('>=desktop'), "{width:", global.tabletMaxWidth, ";}");